import $ from 'jquery';

export default {
	init() {
		console.log('Nylon Resources');

		if (
			window.location.href.indexOf('?_sft_post-topic') > -1 ||
			window.location.href.indexOf('?_sft_news-type') > -1
		) {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $('.ai-block-insights-filter').offset().top,
				},
				300
			);
		}
	},
	finalize() {},
};
